import { combineReducers } from 'redux';

import {
  CLEAR_WAITING_LIST_INFO,
  CLEAR_WAITING_LIST_TIMES,
  SET_WAITING_LIST_INFO,
  SET_WAITING_LIST_TIMES,
} from '../constants';

const waitingListTimes = (state = {}, { type, payload }) => {
  switch (type) {
    case CLEAR_WAITING_LIST_TIMES:
      return {};
    case SET_WAITING_LIST_TIMES:
      return payload;
    default:
      return state;
  }
};

const waitingListInfo = (state = {}, { type, payload }) => {
  switch (type) {
    case CLEAR_WAITING_LIST_INFO:
      return {};
    case SET_WAITING_LIST_INFO:
      return { ...payload };
    default:
      return state;
  }
};

const reducer = combineReducers({
  waitingListTimes,
  waitingListInfo,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/app/waitingList/reducer.js